// extracted by mini-css-extract-plugin
module.exports = {"message":"Indicator_message__nkh61","indicator":"Indicator_indicator__zzN6u","not-active":"Indicator_not-active__2yxe2","value":"Indicator_value__1aDHB"};